import { PATH_BUILDER } from 'constants/actionTypes';

// eslint-disable-next-line
export default function (reporting, action) {
  const updateState = changes => ({ ...reporting, ...changes });
  switch (action.type) {
    case PATH_BUILDER.REPORTING.SET_GROUP:
      return updateState({ groupId: action.id });

    case PATH_BUILDER.REPORTING.DATA_REQUEST:
      return updateState({ loading: true });

    case PATH_BUILDER.REPORTING.DATA_SUCCESS:
      return updateState({ loading: false, ...action.data });

    default:
      return reporting || {};
  }
}
